import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logoutUser } from '../store/slices/authSlice';
import { Link } from 'react-router-dom';
import Logo from '../components/LogoHeader'
import ProfileIcon from '../components/icons/ProfileIcon'
import HamburgerIcon from '../components/icons/HamburgerIcon'
import CloseIcon from '../components/icons/CloseIcon'
import EmailIcon from '../components/icons/EmailIcon'

const GuestHeader = () => {

    const { token } = useSelector((state) => state.auth);
    const isLoggedIn = token ? true : false;
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.auth.isLoading);

    const handleLogout = () => {
        dispatch(logoutUser());
    };

    return (
        <>
            <header className="w-full px-5 h-[60px] flex fixed justify-between items-center border-b border-custom-charcoal bg-custom-dark z-50">
            <div className='inline-block'>
                <Logo />
            </div>
                
               
            <div className="flex gap-3 sm:gap-4 md:gap-5 items-center">
                {!isLoggedIn && (
                    <>
                        <Link to="/register" className='hidden sm:inline-block'>Sign Up</Link>
                        <Link to="/login" className='hidden sm:inline-block'>Log In</Link>
                    </>
                )}
                {isLoggedIn && (
                    <>
                        <Link to="/" className='hidden sm:inline-block'>Map</Link>
                        <Link to="/saved-spots" className='hidden sm:inline-block'>My Spots</Link>
                        <Link to="/settings" className='hidden sm:inline-block'>Settings</Link>
                        <Link to="/info" className='hidden sm:inline-block'>Info</Link>
                    </>
                )}
                <Link to="mailto:info@oreca.pro?subject=Enquiry from Oreca Pro Website" className='inline-block'>
                    <EmailIcon />
                </Link>
                <button className={`cursor-pointer ${isLoggedIn ? '' : 'sm:hidden'}`} type="button" onClick={() => setOpen(!open)}>
                    {open ? (<CloseIcon />) : isLoggedIn ? (<ProfileIcon />) : (<HamburgerIcon />)}
                </button>
            </div>
            </header>
            <nav 
                className={
                    `fixed ${isLoggedIn ? '' : 'sm:hidden'} top-[60px] w-full h-[100vh] bg-custom-darker sm:max-w-[300px] z-[1000] text-lg sm:text-sm
                    ${open ? 'right-0' : 'right-[-100%]'}
                    transition-all ease-in-out duration-500 border-l border-custom-charcoal`
                }
            >
                {isLoggedIn ? (
                    <ul>
                        <li>
                            <Link to="/account/overview" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Account</Link>
                        </li>
                        <li className='sm:hidden'>
                            <Link to="/saved-spots" className='block w-full px-5 py-4 border-b border-custom-charcoal'>My Spots</Link>
                        </li>
                        <li className='sm:hidden'>
                            <Link to="/settings" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Settings</Link>
                        </li>
                        <li>
                            <button onClick={handleLogout} className='block w-full px-5 py-4 border-b border-custom-charcoal text-left'>
                                {isLoading ? 'Logging out...' : 'Logout'}
                            </button>
                        </li>
                    </ul>
                ) : (
                    <ul>
                        <li>
                            <Link to="/register" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Sign Up</Link>
                        </li>
                        <li>
                            <Link to="/login" className='block w-full px-5 py-4 border-b border-custom-charcoal'>Log In</Link>
                        </li>
                    </ul>
                )}
                
            </nav>
        </>
    );
};

export default GuestHeader;
